import React from 'react';
import TokenType from '../Enums/TokenType';

export type TokenContextProps = {
    token: string | null,
    setToken: (value: string | null) => void,
    refreshToken: string | null,
    setRefreshToken: (value: string | null) => void,
    expiration: Date | null,
    setExpiration: (value: Date | null) => void,
    tokenType: TokenType,
    setTokenType: (value: TokenType) => void,
};

const TokenContext: React.Context<TokenContextProps> = React.createContext<TokenContextProps>({
    token: null,
    setToken: () => {},
    refreshToken: null,
    setRefreshToken: () => {},
    expiration: null,
    setExpiration: () => {},
    tokenType: TokenType.TENANT,
    setTokenType: () => {},
});

export default TokenContext;